// extracted by mini-css-extract-plugin
export var cardHeader = "_fp-0";
export var reorderHandle = "_fp-3";
export var titleArea = "_fp-1";
export var titleAreaWithHandle = "_fp-2";